import React, { useState, useEffect, useContext } from "react";
import { Images } from "../../theme";
import { Footer, LoginHeader } from "../../components";
import { Link, useNavigate } from "react-router-dom";
import { Header, SearchCard } from "../../components";
import { GlobalContext } from "../../context/GlobalContext";
import { useTranslation } from "react-i18next";
import "./style.css";
import Tooltip from "@material-ui/core/Tooltip";

export default (props) => {
  let navigate = useNavigate();
  const getcategory = useContext(GlobalContext);
  let { searchText, renderSearch, user_data, loginData } = getcategory;
  const { t } = useTranslation();

  useEffect(() => {
    user_data();
    window.scrollTo(0, 0);
  }, []);

  const checkValidation = () => {
    if (searchText) {
      navigate("/searchbycategory");
    }
  };
  return (
    <div>
      {loginData?.id ? <Header /> : <LoginHeader />}
      <div className="container">
        <div className="row">
          <div className="col-12 mt-3 mb-3">
            <span className="homeHeading">{t("Home")}</span>
            <span className="arrowStyle">
              {" "}
              <img src={Images.ArrowNew} alt="image" />{" "}
            </span>
            <span className="pageHeading">{t("Search")}</span>
          </div>
        </div>
        <div className="row  my-4 py-4">
          <div className="col-lg-6">
            <p className="mb-0 dashboard_heading">
              {t("Rent")}{" "}
              <label className="dashboard_heading" style={{ color: "#005494" }}>
                {t("Cameras")}{" "}
              </label>{" "}
              {t("From")}
            </p>

            <p className="mb-0 dashboard_heading">
              <label className="dashboard_heading" style={{ color: "#005494" }}>
                {t("People")}
              </label>{" "}
              {t("In_Your")}
            </p>

            <p className="mb-0 dashboard_heading">{t("Community")}</p>
            <p className="mt-2 dashboard-sub" style={{ fontSize: 22 }}>
              {t("Community_Description_1")} <br />{" "}
              {t("Community_Description_2")}
            </p>
          </div>
          <div className="col-lg-1"></div>
          <div className="col-lg-5">
            <img className="w-100" src={Images.placeholder} alt="image" />
          </div>
        </div>
        <div className="row mt-5">
          <div className="col-lg-2"></div>
          <div className="col-lg-8">
            <p className="mb-0 dashboard_heading">{t("Search_By_Term")}</p>
          </div>
          <div className="col-lg-2"></div>
        </div>
        <div className="row mt-5">
          <div className="col-lg-2"></div>
          <div className="col-lg-8">
            <div
              style={{ width: "100%" }}
              class="input-slider input-group mb-3"
            >
              <input
                style={{ background: "#fff" }}
                type="text"
                class="form-control Montserrat"
                placeholder={t("Search_Here")}
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                value={searchText}
                onChange={(e) => renderSearch(e.target.value)}
              />
              <Tooltip
                title={
                  searchText.length
                    ? `${t("Search")}`
                    : `${t("Please_Type_Some")}`
                }
              >
                <div class="input-group-append">
                  <button
                    class="bttn btn btn-outline-secondary search-btn"
                    type="button"
                    onClick={() => checkValidation()}
                  >
                    {t("Search")}
                  </button>
                </div>
              </Tooltip>
            </div>
          </div>
          <div className="col-lg-2"></div>
        </div>
        <div className="row mt-5">
          <div className="col-lg-12">
            <p className="mb-0 dashboard_heading  mt-5">
              {t("Search_By_Category")}
            </p>
          </div>
        </div>
        <SearchCard />
      </div>

      <Footer />
    </div>
  );
};
